export default function (value, separator = ', ') {
    return Array.isArray(value) ? value.join(separator) : value;
}
